import React, {lazy, Suspense} from 'react';
import {Route, Redirect, Switch} from 'react-router-dom';
import Loader from 'ui/atoms/Loader';

import {useAuthFetch} from 'context/fetch-context';
import AdminRoutes from 'routes/AdminRoutes';
import {AppProviders} from 'context';

const Home = lazy(() => import('pages/Home'));
const ViewBooking = lazy(() => import('pages/ViewBooking'));
const MakeBooking = lazy(() => import('pages/MakeBooking'));
const TeamBookings = lazy(() => import('pages/TeamBookings'));
const DesignSystem = lazy(() => import('pages/DesignSystem'));
const ErrorPage = lazy(() => import('pages/Error/ErrorPage'));
const Splash = lazy(() => import('pages/Splash'));
const FloorDrawer = lazy(() => import('pages/FloorDrawer'));
// const AddParkingStep = lazy(() => import('ui/organisms/parking/AddParkingStep'));
// const DefineParkingSpaces = lazy(() => import('ui/organisms/parking/DefineParkingSpaces'));

export const AuthRoute = ({children, ...rest}) => {
  const {account} = useAuthFetch();
  return (
    <Route {...rest} render={() => (account ? children : <Redirect push to="/splash" />)}></Route>
  );
};

const App = () => (
  <AppProviders>
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route path="/drawer">
          <FloorDrawer />
        </Route>
        <AuthRoute exact path="(/|/[a-z0-9]*/cancel/booking)">
          <Home />
        </AuthRoute>
        <AuthRoute exact path="(/|/[a-z0-9]*/cancel/parking)">
          <Home />
        </AuthRoute>
        <AuthRoute exact path="/booking/create">
          <MakeBooking />
        </AuthRoute>
        {/*<AuthRoute exact path="/booking/addParking">
          <AddParkingStep />
        </AuthRoute>*/}
        {/*<AuthRoute exact path="/booking/defineParking">
          <DefineParkingSpaces />
        </AuthRoute>*/}
        <AuthRoute exact path="/booking/:bookingId/edit">
          <MakeBooking isEdit />
        </AuthRoute>
        <AuthRoute exact path="/booking/:bookingId">
          <ViewBooking />
        </AuthRoute>
        <AuthRoute exact path="/booking/team/:date">
          <TeamBookings />
        </AuthRoute>
        <AuthRoute path="/(facilities|parking-bans|users|dashboard|guest-cards)">
          <AdminRoutes />
        </AuthRoute>
        <AuthRoute exact path="/styleguide">
          <DesignSystem />
        </AuthRoute>
        <Route exact path="/splash">
          <Splash />
        </Route>
        <Route exact path="/error">
          <ErrorPage />
        </Route>
        <Redirect to="/" />
      </Switch>
    </Suspense>
  </AppProviders>
);

export default App;
